module.exports = __webpack_public_path__ + "img/ic-sim-card-gradient-64-px.15595a6b.svg";